import { showAlert } from '@/components';

/**
 * Centralized error handler for API calls.
 * @param {Error} error - Caught error
 * @param {string} defaultMsg - Fallback error message
 */
export const handleApiError = (
  error,
  defaultMsg = 'An error occurred',
  statusCode,
) => {
  let message = defaultMsg;
  const status =
    typeof statusCode !== 'undefined' ? statusCode : error?.response?.status;

  if (status === 404) {
    message =
      'Resource not found (404). Please check the URL or try again later.';
  } else if (status === 500) {
    message = 'Server error (500). Please try again after some time.';
  } else if (status === 401) {
    message = 'Unauthorized access (401). Please login again.';
  } else if (status === 403) {
    message =
      'Forbidden (403): You are not authorized to access this resource.';
  } else if (status === 502) {
    message = 'Bad Gateway (502). The server is currently unavailable.';
  } else {
    message =
      error?.response?.data?.message ||
      error?.response?.data ||
      error?.message ||
      defaultMsg;
  }

  // showAlert is imported from ToastContainer.jsx
  // Usage: showAlert('error', message);
  if (typeof window !== 'undefined' && window.showAlert) {
    window.showAlert('error', message);
  } else if (typeof showAlert === 'function') {
    showAlert('error', message);
  } else {
    // fallback: log to console
    console.error('Message:', message);
  }
  throw error;
};
